<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-6">
        <span class="h2 e-text-red text-uppercase font-weight-bold">VESSEL AUDIT SCHEDULES</span>
      </div>
      <div class="col-sm-12 col-md-2 col-lg-2 d-flex justify-content-center align-items-center pr-2">
        <select class="form-control form-control-sm" v-model="params.active" @change="setVesselsToTable(1)">
          <option :value="null">ALL STATUS</option>
          <option :value="1" class="bg-light">ACTIVE</option>
          <option :value="0" class="bg-light">INACTIVE</option>
        </select>
      </div>
      <div class="col-sm-12 col-md-4 col-lg-4 d-flex justify-content-center align-items-center pl-0">
        <input type="text" name="vesselSearch" class="form-control form-control-sm" v-model="params.query" placeholder="Search Vessel">
      </div>
    </div>

    <hr style="border-top: 3px solid #e1e1e1">

    <div class="row">
      <div class="col-sm-12 col-md-8 col-lg-8">
        <nav aria-label="...">
          <ul class="pagination text-smallest mb-0 pb-0">
            <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
              <button class="page-link" @click="setVesselsToTable(1)">First</button>
            </li>

            <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
              <button class="page-link" @click="setVesselsToTable(page)">{{ page }}</button>
            </li>

            <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
              <button class="page-link" @click="setVesselsToTable(pagination.lastPage)">Last</button>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-12">
        <div style="height: 74.5vh; overflow-y: auto">
          <div class="card">
            <div class="card-body p-0">
              <table class="table table-bordered mb-0">
                <thead style="position: sticky; top: 0; z-index: 2">
                <tr style="box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);">
                  <th class="text-center text-uppercase bg-f3f3f3 p-2" style="width: 3em" scope="col">#</th>
                  <th class="text-center text-uppercase bg-f3f3f3 p-2" style="width: 20%">Ship Name</th>
                  <th class="text-center text-uppercase bg-f3f3f3 p-2" style="width: 15%">Audit Types</th>
                  <th class="text-center text-uppercase bg-f3f3f3 p-2" style="width: 15%">Next Due Date Display</th>
                  <th class="text-center text-uppercase bg-f3f3f3 p-2">Due Month</th>
                  <th class="text-center text-uppercase bg-f3f3f3 p-2">Due Day</th>
                  <th class="text-center text-uppercase bg-f3f3f3 p-2" style="width: 8em">Status</th>
                  <th class="text-center text-uppercase bg-f3f3f3 p-2" style="width: 8em">Action</th>
                </tr>
                </thead>
                <tbody>
                <template v-if="loading">
                  <tr>
                    <td colspan="100%">
                      <app-loading></app-loading>
                    </td>
                  </tr>
                </template>
                <template v-else-if="!loading && !vesselsAuditSchedule.length">
                  <tr>
                    <td colspan="100%">
                      <div class="p-4 text-center">
                        <h4 class="font-weight-bold text-uppercase" style="color: black">No Data Found</h4>
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr v-for="(vessel, index) in vesselsAuditSchedule" :key="vessel.id" :class="{ 'table-warning-bg': hasChanges(vessel.id) }">
                    <!-- # -->
                    <td class="align-middle text-center text-uppercase">{{ index + pagination.from }}</td>

                    <!-- Ship Name -->
                    <td class="align-middle text-center text-uppercase font-weight-bold">{{ vessel.vessel_name }}</td>

                    <!-- Audit Types Stacked -->
                    <td class="p-0 align-middle">
                      <div class="audit-row p-2 font-weight-bold text-center"
                           :class="{ 'hover-active': activeHover === `${vessel.id}-sms` }"
                           @mouseenter="activeHover = `${vessel.id}-sms`"
                           @mouseleave="activeHover = null">
                        SMS
                      </div>
                      <div class="audit-row p-2 font-weight-bold text-center"
                           :class="{ 'hover-active': activeHover === `${vessel.id}-isps` }"
                           @mouseenter="activeHover = `${vessel.id}-isps`"
                           @mouseleave="activeHover = null">
                        ISPS
                      </div>
                      <div class="audit-row p-2 font-weight-bold text-center border-0"
                           :class="{ 'hover-active': activeHover === `${vessel.id}-cyber` }"
                           @mouseenter="activeHover = `${vessel.id}-cyber`"
                           @mouseleave="activeHover = null">
                        CYBER
                      </div>
                    </td>

                    <td class="p-0 align-middle">
                      <div class="audit-row p-2 font-weight-bold text-center"
                           :class="{ 'hover-active': activeHover === `${vessel.id}-sms` }"
                           @mouseenter="activeHover = `${vessel.id}-sms`"
                           @mouseleave="activeHover = null">
                        {{ vessel?.sms?.settings_sms_next_due_display }}
                      </div>
                      <div class="audit-row p-2 font-weight-bold text-center"
                           :class="{ 'hover-active': activeHover === `${vessel.id}-isps` }"
                           @mouseenter="activeHover = `${vessel.id}-isps`"
                           @mouseleave="activeHover = null">
                        {{ vessel?.isps?.settings_isps_next_due_display }}
                      </div>
                      <div class="audit-row p-2 font-weight-bold text-center border-0"
                           :class="{ 'hover-active': activeHover === `${vessel.id}-cyber` }"
                           @mouseenter="activeHover = `${vessel.id}-cyber`"
                           @mouseleave="activeHover = null">
                        {{ vessel?.cyber?.settings_cyber_next_due_display }}
                      </div>
                    </td>



                    <!-- Due Month Dropdowns -->
                    <td class="p-0 align-middle">
                      <!-- SMS Month -->
                      <div class="audit-row p-1"
                           :class="{ 'hover-active': activeHover === `${vessel.id}-sms` }"
                           @mouseenter="activeHover = `${vessel.id}-sms`"
                           @mouseleave="activeHover = null">
                        <select class="form-control form-control-sm text-center custom-select-sm"
                                :disabled="savingMap[vessel.id]"
                                v-model="getSchedule(vessel).sms_due_month">
                          <option :value="null">-- SELECT MONTH --</option>
                          <option v-for="m in months" :key="'sms-m-' + m.value" :value="m.value">{{ m.name }}</option>
                        </select>
                      </div>
                      <!-- ISPS Month -->
                      <div class="audit-row p-1"
                           :class="{ 'hover-active': activeHover === `${vessel.id}-isps` }"
                           @mouseenter="activeHover = `${vessel.id}-isps`"
                           @mouseleave="activeHover = null">
                        <select class="form-control form-control-sm text-center custom-select-sm"
                                :disabled="savingMap[vessel.id]"
                                v-model="getSchedule(vessel).isps_due_month">
                          <option :value="null">-- SELECT MONTH --</option>
                          <option v-for="m in months" :key="'isps-m-' + m.value" :value="m.value">{{ m.name }}</option>
                        </select>
                      </div>
                      <!-- Cyber Month -->
                      <div class="audit-row p-1 border-0"
                           :class="{ 'hover-active': activeHover === `${vessel.id}-cyber` }"
                           @mouseenter="activeHover = `${vessel.id}-cyber`"
                           @mouseleave="activeHover = null">
                        <select class="form-control form-control-sm text-center custom-select-sm"
                                :disabled="savingMap[vessel.id]"
                                v-model="getSchedule(vessel).cyber_due_month">
                          <option :value="null">-- SELECT MONTH --</option>
                          <option v-for="m in months" :key="'cyber-m-' + m.value" :value="m.value">{{ m.name }}</option>
                        </select>
                      </div>
                    </td>

                    <!-- Due Day Dropdowns -->
                    <td class="p-0 align-middle">
                      <!-- SMS Day -->
                      <div class="audit-row p-1"
                           :class="{ 'hover-active': activeHover === `${vessel.id}-sms` }"
                           @mouseenter="activeHover = `${vessel.id}-sms`"
                           @mouseleave="activeHover = null">
                        <select class="form-control form-control-sm text-center custom-select-sm"
                                :disabled="savingMap[vessel.id]"
                                v-model="getSchedule(vessel).sms_due_day">
                          <option :value="null">-- SELECT DAY --</option>
                          <option v-for="d in 31" :key="'sms-d-' + d" :value="d">{{ d }}</option>
                        </select>
                      </div>
                      <!-- ISPS Day -->
                      <div class="audit-row p-1"
                           :class="{ 'hover-active': activeHover === `${vessel.id}-isps` }"
                           @mouseenter="activeHover = `${vessel.id}-isps`"
                           @mouseleave="activeHover = null">
                        <select class="form-control form-control-sm text-center custom-select-sm"
                                :disabled="savingMap[vessel.id]"
                                v-model="getSchedule(vessel).isps_due_day">
                          <option :value="null">-- SELECT DAY --</option>
                          <option v-for="d in 31" :key="'isps-d-' + d" :value="d">{{ d }}</option>
                        </select>
                      </div>
                      <!-- Cyber Day -->
                      <div class="audit-row p-1 border-0"
                           :class="{ 'hover-active': activeHover === `${vessel.id}-cyber` }"
                           @mouseenter="activeHover = `${vessel.id}-cyber`"
                           @mouseleave="activeHover = null">
                        <select class="form-control form-control-sm text-center custom-select-sm"
                                :disabled="savingMap[vessel.id]"
                                v-model="getSchedule(vessel).cyber_due_day">
                          <option :value="null">-- SELECT DAY --</option>
                          <option v-for="d in 31" :key="'cyber-d-' + d" :value="d">{{ d }}</option>
                        </select>
                      </div>
                    </td>

                    <!-- Status -->
                    <td class="align-middle text-center">
                      <span :class="vessel.active == 1 ? 'badge badge-success' : 'badge badge-secondary'">
                        {{ vessel.active == 1 ? 'ACTIVE' : 'INACTIVE' }}
                      </span>
                    </td>

                    <!-- Action Column -->
                    <td class="align-middle text-center">
                      <template v-if="hasChanges(vessel.id)">
                        <div class="btn-group-vertical btn-group-sm">
                          <button class="btn btn-sm btn-primary mb-1"
                                  :disabled="savingMap[vessel.id]"
                                  @click="saveSchedule(vessel)"
                                  title="Save Changes">
                            <template v-if="savingMap[vessel.id]">
                              <i class="fa fa-spinner fa-spin"></i> Saving...
                            </template>
                            <template v-else>
                              <i class="fa fa-save"></i> Save
                            </template>
                          </button>
                          <button class="btn btn-sm btn-outline-secondary"
                                  :disabled="savingMap[vessel.id]"
                                  @click="resetSchedule(vessel.id)"
                                  title="Discard Changes">
                            <i class="fa fa-undo"></i> Cancel
                          </button>
                        </div>
                      </template>
                      <template v-else>
                        <span class="text-muted small"><em>No changes</em></span>
                      </template>
                    </td>

                  </tr>
                </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { vueAppMixin } from "@/mixins/vueAppMixin";
import AppLoading from "@/components/elements/AppLoading";
import { permissionMixin } from "@/mixins/permissionMixins";
import { AlertService } from "@/services/AlertService";
import { PaginationMixin } from "@/mixins/PaginationMixin";

export default {
  mixins: [vueAppMixin, permissionMixin, PaginationMixin],
  components: { AppLoading },

  name: 'SettingsShipAuditSchedule',
  data() {
    return {
      params: {
        active: null,
        page: 1,
        query: '',
        selectedExportType: ''
      },
      loading: false,
      activeHover: null,
      schedulesMap: {},
      originalSchedulesMap: {},
      savingMap: {}, // Track row-level loading states during API calls
      months: [
        { value: 1, name: 'JANUARY' },
        { value: 2, name: 'FEBRUARY' },
        { value: 3, name: 'MARCH' },
        { value: 4, name: 'APRIL' },
        { value: 5, name: 'MAY' },
        { value: 6, name: 'JUNE' },
        { value: 7, name: 'JULY' },
        { value: 8, name: 'AUGUST' },
        { value: 9, name: 'SEPTEMBER' },
        { value: 10, name: 'OCTOBER' },
        { value: 11, name: 'NOVEMBER' },
        { value: 12, name: 'DECEMBER' }
      ]
    }
  },
  methods: {
    ...mapActions([
      'getVesselsAuditSchedule',
      'updateVesselAuditSchedule'
    ]),

    async setVesselsToTable(page = 1) {
      this.loading = true;
      this.params.page = page;
      await this.getVesselsAuditSchedule(this.params);
      this.initializeSchedules();
      this.loading = false;
    },

    initializeSchedules() {
      const map = {};
      this.vesselsAuditSchedule.forEach(vessel => {
        const sched = vessel.audit_schedules || {};
        map[vessel.id] = {
          vessel_id: vessel.id,
          sms_due_month: sched.sms_due_month ?? null,
          sms_due_day: sched.sms_due_day ?? null,
          isps_due_month: sched.isps_due_month ?? null,
          isps_due_day: sched.isps_due_day ?? null,
          cyber_due_month: sched.cyber_due_month ?? null,
          cyber_due_day: sched.cyber_due_day ?? null,
        };
      });

      this.schedulesMap = map;
      this.originalSchedulesMap = JSON.parse(JSON.stringify(map));
    },

    getSchedule(vessel) {
      if (!this.schedulesMap[vessel.id]) {
        const defaultObj = {
          vessel_id: vessel.id,
          sms_due_month: null, sms_due_day: null,
          isps_due_month: null, isps_due_day: null,
          cyber_due_month: null, cyber_due_day: null,
        };
        this.$set(this.schedulesMap, vessel.id, { ...defaultObj });
        this.$set(this.originalSchedulesMap, vessel.id, { ...defaultObj });
      }
      return this.schedulesMap[vessel.id];
    },

    hasChanges(vesselId) {
      const current = this.schedulesMap[vesselId];
      const original = this.originalSchedulesMap[vesselId];

      if (!current || !original) return false;

      return (
        current.sms_due_month !== original.sms_due_month ||
        current.sms_due_day !== original.sms_due_day ||
        current.isps_due_month !== original.isps_due_month ||
        current.isps_due_day !== original.isps_due_day ||
        current.cyber_due_month !== original.cyber_due_month ||
        current.cyber_due_day !== original.cyber_due_day
      );
    },

    resetSchedule(vesselId) {
      if (this.originalSchedulesMap[vesselId]) {
        this.schedulesMap[vesselId] = JSON.parse(JSON.stringify(this.originalSchedulesMap[vesselId]));
      }
    },

    validateSchedulePair(month, day, typeLabel) {
      const hasMonth = month !== null && month !== '';
      const hasDay = day !== null && day !== '';

      if (hasMonth && !hasDay) {
        return `The ${typeLabel} due day is required when ${typeLabel} month is selected.`;
      }
      if (!hasMonth && hasDay) {
        return `The ${typeLabel} due month is required when ${typeLabel} day is selected.`;
      }
      return null;
    },

    async saveSchedule(vessel) {
      const schedule = this.schedulesMap[vessel.id];

      const smsError = this.validateSchedulePair(schedule.sms_due_month, schedule.sms_due_day, 'SMS');
      const ispsError = this.validateSchedulePair(schedule.isps_due_month, schedule.isps_due_day, 'ISPS');
      const cyberError = this.validateSchedulePair(schedule.cyber_due_month, schedule.cyber_due_day, 'CYBER');

      const validationError = smsError || ispsError || cyberError;

      if (validationError) {
        return AlertService.errorAlert(validationError, `${vessel.name} AUDIT SCHEDULE`);
      }

      const payload = {
        vessel_id: vessel.id,
        sms_due_month: schedule.sms_due_month ?? null,
        sms_due_day: schedule.sms_due_day ?? null,
        isps_due_month: schedule.isps_due_month ?? null,
        isps_due_day: schedule.isps_due_day ?? null,
        cyber_due_month: schedule.cyber_due_month ?? null,
        cyber_due_day: schedule.cyber_due_day ?? null,
      };

      // Set loader state for this row
      this.$set(this.savingMap, vessel.id, true);

      try {
        await this.updateVesselAuditSchedule(payload);

        this.originalSchedulesMap[vessel.id] = JSON.parse(JSON.stringify(schedule));

        if (typeof AlertService !== 'undefined' && AlertService.successAlert) {
          AlertService.successAlert('Audit schedule updated successfully', 'AUDIT SCHEDULE');
        }
      } catch (error) {
        if (typeof AlertService !== 'undefined' && AlertService.error) {
          AlertService.error(error?.response?.data?.message || 'Failed to update schedule');
        }
      } finally {
        // Clear loader state
        this.$set(this.savingMap, vessel.id, false);
      }
    }
  },

  computed: {
    ...mapGetters([
      'pagination',
      'vesselList',
      'vesselsAuditSchedule',
    ])
  },

  async created() {
    await this.setVesselsToTable();
    const { default: debounce } = await import('lodash.debounce');
    this.setVessels = debounce(this.setVesselsToTable, 750);
  },

  watch: {
    'params.query'() {
      this.setVessels();
    }
  },

  destroyed() {
    this.params.active = 1;
  }
}
</script>

<style scoped lang="scss">
.bg-f3f3f3 {
  background: #e9e9e9;
  border: 2px solid #e1e1e1;
  color: black;
}

.audit-row {
  border-bottom: 1px solid #dee2e6;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.15s ease-in-out;
}

.hover-active {
  background-color: #e2f0ff !important;

  select {
    background-color: #ffffff !important;
    border-color: #007bff !important;
  }
}

.custom-select-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.875rem;
}

.table-warning-bg {
  background-color: #fff9e6;
}
</style>
